import { getError } from "@/utils/helpers";
import ClientService from "@/services/ClientService";

export const namespaced = true;

export const state = {
  clientSingle: [],
  loading: false,
  error: null,
};

export const mutations = {
  SET_CLIENTSINGLE(state, clientSingle) {
    state.clientSingle = clientSingle;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

export const actions = {
  getClient({ commit }, ClientId) {
    commit("SET_LOADING", true);

    ClientService.getClient(ClientId)
      .then((response) => {
        commit("SET_CLIENTSINGLE", response.data.data);
      })
      .catch((error) => {
        commit("SET_LOADING", false);
        commit("SET_ERROR", getError(error));
      })
      .finally(() => {
        commit("SET_LOADING", false);
      });
  },
};
export const getters = {
  clientSingle: (state) => {
    return state.clientSingle;
  },
  loading: (state) => {
    return state.loading;
  },
  error: (state) => {
    return state.error;
  },
};
